import BreadCrumb from "Components/Common/BreadCrumb";
import React, { useCallback, useState } from "react";
import { useEffect } from "react";
import {
  Container,
  CardBody,
  Card,
  Input,
  Label,
  Form,
  Row,
  Col,
  Media,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { updateBussinessInformation, getBank } from "live-slices/thunk";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { Link, useNavigate } from "react-router-dom";
import {
  FirebaseAuthBackend,
  getFirebaseBackend,
} from "helpers/firebase_helper";
import Loader from "Components/Common/Loader";
import AddressFormBox from "Components/Common/AddressFormBox";
import ImageViewer from "Components/Common/ImageViewer";
import MediaUploader from "Components/Common/MediaUploader";
import BuypassAddressSelector, {
  AddressModel,
  BuypassAdressValidationSchema,
} from "Components/Common/BuypassAddressSelector";

const BusinessInformationModify = () => {
  document.title = "Business Information | BuyPass";

  const selectuserProfile = createSelector(
    (state: any) => state.Business,
    (business) => business?.business
  );
  const [selectImageLoading, setSelectImageLoading] = useState<any>(false);
  const [selectedFrontCnicImage, setSelectedFrontCnicImage] = useState<any>();
  const [selectBackCnicImageLoading, setSelectBackCnicImageLoading] =
    useState<any>(false);
  const [selectFrontCnicImageLoading, setSelectFrontCnicImageLoading] =
    useState<any>(false);
  const [selectedBackCnicImage, setSelectedBackCnicImage] = useState<any>();
  const [selectedFiles, setselectedFiles] = useState<any>([]);
  const [isSelectedFilesLoading, setIsSelectedFilesLoading] =
    useState<any>(false);
  const [isToggled, setIsToggled] = useState(false);
  const [isBusinessAddressSame, setIsBusinessAddressSame] = useState(false);
  async function handleAcceptedFiles(files: any) {
    setIsSelectedFilesLoading(true);
    let uploadedFiles: any[] = [...selectedFiles];
    for (let file of files) {
      const url = await firebaesHelper?.uploadImage(file, "product/");
      uploadedFiles.push(getFileObj(file, url));
    }
    setIsSelectedFilesLoading(false);
    setselectedFiles(uploadedFiles);
  }
  const [selectedImage, setSelectedImageFront] = useState<any>();
  const firebaesHelper: FirebaseAuthBackend | null = getFirebaseBackend();
  const [isViewerOpen, setViewerOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const handleImageChange = async (event: any) => {
    setSelectImageLoading(true);
    try {
      const file = event.target.files[0];
      const res = await firebaesHelper?.uploadImage(file, "product/");
      setSelectedImageFront(getFileObj(file, res));
      setSelectImageLoading(false);
    } catch (e) {
      setSelectImageLoading(false);
      console.log(e);
    }
  };

  const closeViewer = () => {
    setViewerOpen(false);
  };

  const openViewer = (imageUrl: string) => {
    setCurrentImage(imageUrl);
    setViewerOpen(true);
  };

  const handleDeleteImage = () => {
    setSelectedImageFront(null);
  };
  const handleToggle = () => {
    const newValue = !isBusinessAddressSame;
    setIsBusinessAddressSame(newValue);
    formik.setFieldValue("isBusinessAddressSame", newValue);
    console.log("update", newValue);
  };

  const seller = useSelector(selectuserProfile);

  useEffect(() => {}, [getBank]);

  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  const handleFieldChange = (key: string, e: any) => {
    formik.setFieldValue(key, e.target.value);
  };

  useEffect(() => {
    if (seller && seller.nationality) {
      if (seller.nationality.cnicBackImage) {
        setSelectedBackCnicImage(seller.nationality.cnicBackImage);
      }
      if (seller.nationality.cnicFrontImage) {
        setSelectedFrontCnicImage(seller.nationality.cnicFrontImage);
      }
    }
    if (seller?.idBankDetails?.isBusinessAddressSame) {
      setIsBusinessAddressSame(seller?.idBankDetails?.isBusinessAddressSame);
    }
    if (seller?.idBankDetails?.businessAddress) {
      const updatedValues = {
        ...formik.values,
        address: {
          ...formik.values.address,
          ...AddressModel.copyFromObject(seller.idBankDetails.businessAddress),
        },
      };
      formik.setValues(updatedValues, false);
    }
  }, [seller]);

  const validationSchema = Yup.object({
    // sellerType: Yup.string()
    //   .required('sellerType is required'),
    companyLegalName: Yup.string().required("The field value is required"),
    // businessAddress: Yup.string()
    //   .required('address is required'),
    personInCharge: Yup.string().required("The field value is required"),
    businessRegistrationNumber: Yup.string().required(
      "The field value is required"
    ),
    cnicNumber: Yup.string()
      .max(15, 'Cnic Number cannot be more than 13 characters')
      .required('The field value is required'),
      personInChargeEmail: Yup.string()
      .required("The field value is required")
      .test(
        "includes-at-and-dot",
        "Invalid email format",
        value => {
          return value?.includes("@") && value.includes(".");
        }
      ),    
    address: Yup.string().when("isBusinessAddressSame", {
      is: (isBusinessAddressSame: boolean) => isBusinessAddressSame === false,
      otherwise: (schema: any) => Yup.object().notRequired(),
      then: (schema: any) => Yup.object(BuypassAdressValidationSchema),
    }),
    // type: Yup.string()
    // .required('type is required'),

    // country: Yup.string()
    //     .required('country is require'),
    // address: Yup.object(BuypassAdressValidationSchema),
  });

  const formik = useFormik({
    initialValues: {
      sellerType: seller?.sellerType,
      companyLegalName: seller?.idBankDetails?.companyLegalName || "",
      country: "pakistan",
      personInCharge: seller?.personInCharge?.personInCharge || "",
      personInChargeEmail: seller?.personInCharge?.personInChargeEmail || "",
      businessRegistrationNumber:
        seller?.idBankDetails?.businessRegistrationNumber || "",
      cnicNumber: seller?.nationality?.cnicNumber || "",
      cnicFrontImage: seller?.nationality?.cnicFrontImage || null,
      cnicBackImage: seller?.nationality?.cnicBackImage || null,
      type: "CNIC",
      // streetAddress: seller?.idBankDetails?.businessAddress?.streetAddress || "",
      isBusinessAddressSame: seller?.idBankDetails?.isBusinessAddressSame,
      address: new AddressModel(),
      businessAddress: isBusinessAddressSame
        ? new AddressModel()
        : seller?.idBankDetails?.businessAddress || new AddressModel(),
    },
    validationSchema,
    onSubmit: (values) => {
      const updateBusiness = {
        values,
        businessAddress: AddressModel.copyFromObject(formik.values.address),
      };
      dispatch(
        updateBussinessInformation({ formData: updateBusiness, navigate })
      );
    },
  });

  const onMediaUpdate = (key: string, value: Media | any) => {
    console.log(key, value);
    if (key === "selectedFrontCnicImage") {
      setSelectedFrontCnicImage(value);
      let url: string | undefined;
      let media: Media | undefined;
      if (Array.isArray(value)) {
        url = value[0]?.url;
        media = value[0];
      } else {
        url = value?.url;
        media = value;
      }
      if (url) {
        formik.setFieldValue("cnicFrontImage.url", url);
      }
    } else if (key === "selectedBackCnicImage") {
      setSelectedBackCnicImage(value);
      let url: string | undefined;
      let media: Media | undefined;
      if (Array.isArray(value)) {
        url = value[0]?.url;
        media = value[0];
      } else {
        url = value?.url;
        media = value;
      }
      if (url) {
        formik.setFieldValue("cnicBackImage.url", url);
      }
    }
  };

  const onWarehouseAddressChange = (businessAddress: any) => {
    formik.setFieldValue("businessAddress", businessAddress);
  };

  const getFileObj = (file: any, url: any) => {
    return {
      url,
      metadata: {
        height: file.height || 0,
        width: file.width || 0,
        fileType: file.type || "string",
        fileFormat: file.name.split(".").pop() || "string",
        name: file.name || "string",
        duration: file.duration || 0,
      },
    };
  };

  const handleBackCnicImageChange = async (event: any) => {
    setSelectBackCnicImageLoading(true);
    try {
      const file = event.target.files[0];
      if (file) {
        const res = await firebaesHelper?.uploadImage(file, "product/");
        const fileObj = getFileObj(file, res);
        setSelectedBackCnicImage(fileObj);
        formik.setFieldValue("cnicBackImage", fileObj.url);
      }
      setSelectBackCnicImageLoading(false);
    } catch (e) {
      setSelectBackCnicImageLoading(false);
      console.log(e);
    }
  };

  const handleDeleteBackCnicImage = () => {
    setSelectedBackCnicImage(null);
  };

  const handleDeleteFrontCnicImage = () => {
    setSelectedFrontCnicImage(null);
  };

  const handleFrontCnicImageChange = async (event: any) => {
    setSelectFrontCnicImageLoading(true);
    try {
      const file = event.target.files[0];
      if (file) {
        const res = await firebaesHelper?.uploadImage(file, "product/");
        const fileObj = getFileObj(file, res);
        setSelectedFrontCnicImage(fileObj);
        formik.setFieldValue("cnicFront", fileObj.url);
      }
    } catch (e) {
      console.error("Error uploading image:", e);
    } finally {
      setSelectFrontCnicImageLoading(false);
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title=" Business Information"
          pageTitle="My-Account "
          pageTitleRoute="/my-account-setting"
        />
        <Form onSubmit={formik.handleSubmit}>
          <Card>
            <CardBody className="rounded-3">
              <Row className="d-grid gap-4 ">
                <Row className="gap-in-row">
                  <Col md={4} xl={4} xs={12}>
                    <div className="formContainer">
                      <label className="form-label" htmlFor="password-input">
                        <span style={{ color: "red", display: "inline" }}>
                          *
                        </span>{" "}
                        Seller Type
                      </label>

                      <Input
                        type="text"
                        name="sellerType"
                        className={`form-control ${
                          formik.touched.sellerType && formik.errors.sellerType
                            ? "is-invalid"
                            : ""
                        }`}
                        id="sellerType"
                        data-testing-Id="sellerTypeInput_businessInformationModify"
                        placeholder=""
                        disabled
                        onChange={(e) => {
                          formik.handleChange(e);
                          handleFieldChange("sellerType", e);
                        }}
                        onBlur={formik.handleBlur}
                        value={
                          formik.values.sellerType
                            ? formik.values.sellerType.charAt(0).toUpperCase() + formik.values.sellerType.slice(1)
                            : ''
                        }
                      />
                      {formik.touched.sellerType &&
                        formik.errors.sellerType && (
                          <div className="invalid-feedback">
                            {formik.errors.sellerType as String}
                          </div>
                        )}
                    </div>
                  </Col>
                  <Col md={4} xl={4} xs={12}>
                    <div className="formContainer">
                      <label className="form-label" htmlFor="password-input">
                        <span style={{ color: "red", display: "inline" }}>
                          *
                        </span>{" "}
                        Legal Company Name{" "}
                      </label>
                      <Input
                        type="text"
                        className={`form-control pe-5 password-input ${
                          formik.touched.companyLegalName &&
                          formik.errors.companyLegalName
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Name and surname of the person who administers and operates..."
                        data-testing-Id="companyLegalNameInput_businessInformationModify"
                        id="companyLegalName"
                        onChange={(e) => {
                          formik.handleChange(e);
                          handleFieldChange("companyLegalName", e);
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.companyLegalName}
                      />
                      {formik.touched.companyLegalName &&
                        formik.errors.companyLegalName && (
                          <div className="invalid-feedback">
                            {formik.errors.companyLegalName as String}
                          </div>
                        )}
                    </div>
                  </Col>

                  <Col md={4} xl={4} xs={12}>
                    <div className="formContainer">
                      <label className="form-label" htmlFor="password-input">
                        <span style={{ color: "red", display: "inline" }}>
                          *
                        </span>{" "}
                        Country/ Region
                      </label>
                      <select
                        className="form-select"
                        name="country"
                        onChange={(e) => {
                          formik.handleChange(e);
                          handleFieldChange("country", e);
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.country
                           ? formik.values.country.charAt(0).toUpperCase() + formik.values.country.slice(1)
                            : ''
                        }
                        data-testing-Id="countrySelect_businessInformationModify"
                      >
                        <option
                          value="Pakistan"
                          data-testing-Id="SelectRegion_businessInformationModify"
                        >
                          Pakistan
                        </option>
                      </select>
                    </div>
                  </Col>
                </Row>

                <Row className="gap-in-row">
                  <Col md={4} xl={4} xs={12}>
                    <div className="formContainer">
                      <label className="form-label" htmlFor="password-input">
                        <span style={{ color: "red", display: "inline" }}>
                          *
                        </span>
                        Person in Charge
                      </label>
                      <Input
                        type="text"
                        className={`form-control pe-5 password-input ${formik.touched.personInCharge && formik.errors.personInCharge ? "is-invalid" : ""}`}
                        placeholder="Enter Name..."
                        id="personInCharge"
                        onChange={(e) => {
                          formik.handleChange(e);
                          handleFieldChange("personInCharge", e);
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.personInCharge}
                        data-testing-Id="personInChargeInput_businessInformationModify"
                      />
                      {formik.touched.personInCharge &&
                        formik.errors.personInCharge && (
                          <div className="invalid-feedback">
                            {formik.errors.personInCharge as String}
                          </div>
                        )}
                    </div>
                  </Col>

                  <Col md={4} xl={4} xs={12}>
                    <div className="formContainer">
                      <label className="form-label" htmlFor="password-input">
                        <span style={{ color: "red", display: "inline" }}>
                          *
                        </span>
                        Person in Email
                      </label>
                      <Input
                        type="text"
                        className={`form-control pe-5 password-input ${
                          formik.touched.personInChargeEmail &&
                          formik.errors.personInChargeEmail
                            ? "is-invalid"
                            : ""
                        }`}
                        placeholder="Enter Email"
                        id="personInChargeEmail"
                        onChange={(e) => {
                          formik.handleChange(e);
                          handleFieldChange("personInChargeEmail", e);
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.personInChargeEmail}
                        data-testing-Id="personInChargeInput_businessInformationModify"
                      />
                      {formik.touched.personInChargeEmail &&
                        formik.errors.personInChargeEmail && (
                          <div className="invalid-feedback">
                            {formik.errors.personInChargeEmail as String}
                          </div>
                        )}
                    </div>
                  </Col>
                  <Col md={4} xl={4} xs={12}>
                    <div className="formContainer">
                      <label className="form-label" htmlFor="password-input">
                        <span style={{ color: "red", display: "inline" }}>
                          *
                        </span>{" "}
                        Business Registration Number / NTN{" "}
                      </label>
                      <Input
                        type="text"
                        className={`form-control pe-5 password-input ${formik.touched.businessRegistrationNumber && formik.errors.businessRegistrationNumber ? "is-invalid" : ""}`}
                        placeholder="Enter Bussiness Registration..."
                        id="businessRegistrationNumber"
                        onChange={(e) => {
                          formik.handleChange(e);
                          handleFieldChange("businessRegistrationNumber", e);
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.businessRegistrationNumber}
                        disabled={(seller?.idBankDetails?.businessRegistrationNumber || "").trim() !== ""}
                        data-testing-Id="businessRegistrationNumberInput_businessInformationModify"
                      />
                      {formik.touched.businessRegistrationNumber &&
                        formik.errors.businessRegistrationNumber && (
                          <div className="invalid-feedback">
                            {formik.errors.businessRegistrationNumber as String}
                          </div>
                        )}
                    </div>
                  </Col>
                  <Col md={4} xl={4} xs={12}>
                    <div className="formContainer mt-4">
                      <label className="form-label" htmlFor="password-input">
                        <span style={{ color: "red", display: "inline" }}>
                          *
                        </span>{" "}
                        CNIC Number
                      </label>
                      <Input
                        type="text"
                        name="cnicNumber"
                        className={`form-control ${
                          formik.touched.cnicNumber &&
                          (formik.errors.cnicNumber ||
                            formik.values.cnicNumber.length > 15)
                            ? "is-invalid"
                            : ""
                        }`}
                        id="cnicNumber"
                        placeholder="The official number on ID"
                        onChange={(e) => {
                          let value = e.target.value.replace(/\D/g, "");
                          if (value.length > 13) value = value.slice(0, 13);
                          if (value.length > 5)
                            value = `${value.slice(0, 5)}-${value.slice(5)}`;
                          if (value.length > 13)
                            value = `${value.slice(0, 13)}-${value.slice(13)}`;
                          formik.setFieldValue("cnicNumber", value);
                          handleFieldChange("cnicNumber", {
                            target: { value },
                          });
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.cnicNumber}
                        data-testing-id="cnicCardNumberInput_BankInformTwo"
                      />
                      {formik.touched.cnicNumber &&
                        formik.errors.cnicNumber && (
                          <div className="invalid-feedback">
                            {formik.errors.cnicNumber as String}
                          </div>
                        )}
                    </div>
                  </Col>
                  <Col md={4} xl={4} xs={12}>
                    <div className="formContainer mt-4">
                      <label className="form-label" htmlFor="password-input">
                        {" "}
                        ID Type{" "}
                      </label>
                      <select
                        className="form-select"
                        name="type"
                        onChange={(e) => {
                          formik.handleChange(e);
                          handleFieldChange("type", e);
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.type}
                        data-testing-Id="idTypeSelect_businessInformationModify"
                      >
                        <option
                          value="CNIC"
                          data-testing-Id="cnicSelect_businessInformationModify"
                        >
                          CNIC
                        </option>
                      </select>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md={4} xl={4}>
                    <h6 className="fw-bold ">
                      {" "}
                      <span className="text-danger me-1">*</span>Upload ID -
                      Front Side
                      <span>
                        <i className="ri-information-line ms-2 fs-5 fw-normal"></i>
                      </span>
                    </h6>

                    <MediaUploader
                      onMediaUpdate={(value: any) =>
                        onMediaUpdate("selectedFrontCnicImage", value)
                      }
                      isMultiple={false}
                      initialMedia={seller.nationality.cnicFrontImage}
                    />
                  </Col>
                  <ImageViewer
                    isOpen={isViewerOpen}
                    imageUrl={currentImage}
                    toggle={closeViewer}
                  />
                  <Col md={4} xl={4}>
                    <h6 className="fw-bold ">
                      {" "}
                      <span className="text-danger me-1">*</span>Upload ID -
                      Back Side
                      <span>
                        <i className="ri-information-line ms-2 fs-5 fw-normal"></i>
                      </span>
                    </h6>
                    <MediaUploader
                      onMediaUpdate={(value: any) =>
                        onMediaUpdate("selectedBackCnicImage", value)
                      }
                      isMultiple={false}
                      initialMedia={seller.nationality.cnicBackImage}
                    />
                  </Col>
                </Row>

                <div>
                  <Row className="businessAddress">
                    <h6 className="fw-bold">
                      <span className="text-danger">*</span> Address
                      <span>
                        <i className="ri-information-line ms-2 fs-5 fw-normal"></i>
                      </span>
                    </h6>
                    <div className="form-check form-switch ms-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={isBusinessAddressSame}
                        onChange={handleToggle}
                        data-testing-id="sameAdress_businessInformationmodify"
                      />
                      <p>Same as Shop Address</p>
                    </div>

                    {!isBusinessAddressSame && (
                      <BuypassAddressSelector formik={formik} />
                    )}
                  </Row>
                </div>
              </Row>
            </CardBody>
          </Card>
          <Card>
            <CardBody className="rounded-3 text-end">
              <Link to="/business-information" className="  ">
                <button
                  type="button"
                  className="btn btn-outline-secondary  me-2"
                  data-testing-Id="cancelButton_businessInformationModify"
                >
                  Cancel
                </button>
              </Link>
              <button
                type="submit"
                className="btn btn-secondary ms-auto"
                data-testing-Id="submitButton_businessInformationModify"
              >
                Submit
              </button>
            </CardBody>
          </Card>
        </Form>
      </Container>
    </div>
  );
};

export default BusinessInformationModify;
